var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.totalCnt > 0
    ? _c(
        "div",
        [
          _c("div", { staticClass: "total-count" }, [
            _vm._v(
              _vm._s(/*총 건수*/ _vm.$t("MCOM-0000079")) +
                " : " +
                _vm._s(_vm.totalCnt)
            )
          ]),
          _vm._l(_vm.newsList, function(list, i) {
            return _c("ul", { key: i, staticClass: "ulist" }, [
              _c(
                "li",
                {
                  staticClass: "item",
                  on: {
                    click: function($event) {
                      return _vm.goToDetail(list)
                    }
                  }
                },
                [
                  _vm.lang === "KOR"
                    ? _c("span", { staticClass: "tit" }, [
                        _vm._v(_vm._s(list.hanglTitlCtnt))
                      ])
                    : _vm.lang === "ENG"
                    ? _c("span", { staticClass: "tit" }, [
                        _vm._v(_vm._s(list.engTitlCtnt))
                      ])
                    : _c("span", {
                        staticClass: "tit",
                        domProps: { innerHTML: _vm._s(list.lcalTitlCtnt) }
                      }),
                  _c("div", { staticClass: "dec" }, [
                    _c("span", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$getGlobalDateFmt(list.regiYMS.substring(0, 8))
                        )
                      )
                    ]),
                    _vm.lang === "KOR" && !_vm._.isEmpty(list.hangFileList)
                      ? _c("i", { staticClass: "icon icon-download-sm" })
                      : _vm._e(),
                    _vm.lang === "ENG" && !_vm._.isEmpty(list.engFileList)
                      ? _c("i", { staticClass: "icon icon-download-sm" })
                      : _vm._e(),
                    _vm.lang === "LOC" && !_vm._.isEmpty(list.lcalFileList)
                      ? _c("i", { staticClass: "icon icon-download-sm" })
                      : _vm._e()
                  ]),
                  _c("i", { staticClass: "icon icon-arrow-m-right" })
                ]
              )
            ])
          })
        ],
        2
      )
    : _c("div", { staticClass: "empty" }, [
        _vm._m(0),
        _c("strong", { staticClass: "empty-text" }, [
          _vm._v(_vm._s(/*조회 내역이 없습니다.*/ _vm.$t("MCOM-0000015")))
        ])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-img" }, [
      _c("i", { staticClass: "icon icon-opt-no" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }